import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Form, FormGroup, Input, Label } from 'reactstrap';
import './Authform.css';
import { useHistory } from 'react-router-dom';
import axios from '../axios';
import { useStateValue } from '../StateProvider';
import moment from 'moment';
import LoginIcon from '@mui/icons-material/Login';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import {
  Container,
  Dialog,
  FilledInput,
  IconButton,
  InputAdornment,
  InputLabel,
  LinearProgress,
  Stack,
  Button,
} from '@mui/material';
// import toastr from "toastr"
import SweetAlert from 'react-bootstrap-sweetalert';
import { FormControl } from '@material-ui/core';

export const STATE_LOGIN = 'LOGIN';
export const STATE_SIGNUP = 'SIGNUP';
export const STATE_FORGOT_PASSWORD = 'FORGOT_PASSWORD';

function AuthForm({ authState, onChangeAuthState }) {
  const history = useHistory();
  const [openLoader, setOpenLoader] = useState(false);
  const [username, setusername] = useState('');
  const [password, setpassword] = useState('');
  const [userdata, setuserdata] = useState([]);
  const [open, setopen] = useState(false);
  const [user, dispatch] = useStateValue();
  const [customerlogin, setcustomerlogin] = useState(false);
  const [companycollections, setcompanycollections] = useState([]);
  const [companyid, setcompanyid] = useState('');
  const [date, setdate] = useState('');
  const [userAccess, setuserAccess] = useState([])

  // login err
  const [LoginErr, setLoginErr] = useState(false);

  const [tokent, settokent] = useState(
    'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJldmVudGxpc3QiOlt7IlVzZXJJRCI6IjEiLCJMb2dpbkNvZGUiOiIwMSIsIkxvZ2luTmFtZSI6IkFkbWluIiwiRW1haWxJZCI6ImFkbWluQGdtYWlsLmNvbSIsIlVzZXJUeXBlIjoiQURNSU4ifV0sImlhdCI6MTYzODM1NDczMX0.ZW6zEHIXTxfT-QWEzS6-GuY7bRupf2Jc_tp4fXIRabQ',
  );

  useEffect(() => {
    let fromdate = sessionStorage.getItem('contractfromdate1');
    console.log(fromdate, 'fryys');
  }, []);

  const Getuserrole = async () => {
    let tokent = sessionStorage.getItem('authtoken');

    const role = await axios.instance
      .get(`/GetOneSupplierDetails/${sessionStorage.getItem('Userid')}`, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      })
      .then(res => {
        let userData = Array.isArray(res.data) ? res.data : [res.data];

        // Store in state
        setuserAccess(userData);

        // Store in sessionStorage (convert to JSON string)
        sessionStorage.setItem('userAccess', JSON.stringify(userData));
        // Fields for "master" validation
        const masterFields = ['company', 'customer', 'customer_Branch', 'product_Category', 'tax', 'uom', 'product'];
        const transactionFields = ['quotation', 'po_Acceptance', 'so_Status_Update'];

        // Function to check if all required fields are 'N'
        const areAllFieldsN = (data, fields) => {
          return fields.every(field => data[field] === 'N');
        };

        const isMasterN = userData.every(user => areAllFieldsN(user, masterFields));
        const isTransactionN = userData.every(user => areAllFieldsN(user, transactionFields));

        console.log(isMasterN, 'isMasterN');
        console.log(isTransactionN, 'isTransactionN');

        // Set sessionStorage values
        sessionStorage.setItem('master', isMasterN ? 'N' : 'Y');
        sessionStorage.setItem('transaction', isTransactionN ? 'N' : 'Y');
      });
  };

  const GetOnecompnayandDetails = id => {
    const token = sessionStorage.getItem('AuthToken');
    axios.instance
      .get(`GetcompnayandDetails/${id}`, {
        headers: {
          Authorization: token,
          'Content-Type': 'application/json',
        },
      })
      .then(res => {
        const Data = res.data[0];
        sessionStorage.setItem('Companyid', Data.Company_Id);
        sessionStorage.setItem('companyName', Data.Company_Name);
        sessionStorage.setItem('CStateCode', Data.StateCode);
        sessionStorage.setItem('CStateId', Data.StateId);
        sessionStorage.setItem('Branch_Log', Data.companybranch);
        sessionStorage.setItem('BranchName', Data.Branch_Name);
        sessionStorage.setItem('CompanyAccessId', Data.CompanyAccessId);
        setcompanyid(false);
      })
      .catch(error => {
        console.error('Error fetching customer access:', error);
      });
  };

  // mis For Yuki new
  const login = async e => {
    setOpenLoader(true);
    if (customerlogin === false) {
      e.preventDefault();
      console.log(password, 'pass');
      if (username.length != 0 && password.length != 0) {
        const logidata = await axios.instance
          .post('/login', {
            User_Code: `${username}`,
            Password: `${password}`,
          })
          .then(async res => {
            console.log(res.data, 'login.data');
            console.log(res.data.getlogin, 'yuki');
            const enabel = res.data.getlogin;
            console.log(res.data.getlogin);
            // Check if getlogin is an empty array
            if (res.data.getlogin.length === 0) {
              setopen(true);
              setOpenLoader(false);
              setTimeout(() => {
                setopen(false);
              }, 2000);
              return;
            }
            console.log(enabel[0].enable_mis);

            if (Object.keys(res.data).length === 2) {
              sessionStorage.setItem('user', JSON.stringify(res.data));

              setuserdata(res.data.eventlist);
              sessionStorage.setItem('authtoken', 'Bearer ' + res.data.token);
              console.log(res.data.getlogin, res.data, 'Yukesh');
              for (const data2 of res.data.getlogin) {

                if (data2.DateRange && data2.DateRange.includes('-')) {
                  const [startDay, endDay] = data2.DateRange.split('-').map(Number);
                  const now = new Date();
                  const year = now.getFullYear();
                  const month = now.getMonth(); // 0-indexed

                  // Use UTC to avoid timezone offsets
                  const startDate = new Date(Date.UTC(year, month, startDay));
                  const endDate = new Date(Date.UTC(year, month, endDay));

                  const format = (date) => date.toISOString().split('T')[0];

                  sessionStorage.setItem('DateRangeStart', format(startDate));
                  sessionStorage.setItem('DateRangeEnd', format(endDate));
                }


                console.log(data2, 'yukesh');
                sessionStorage.setItem('Customer_Name', data2.Customer_Name);
                sessionStorage.setItem('CustomerType', data2.Type);
                sessionStorage.setItem('Companyid', data2.Company_Id);
                sessionStorage.setItem('Customer_Log', data2.Customer_Id);
                sessionStorage.setItem('CustomerName', data2.Customer_Name);
                sessionStorage.setItem('Company_Name', data2.Company_Name);
                sessionStorage.setItem('Branch_name', data2.Branch_Name);
                sessionStorage.setItem('Branch_Log', data2.Branch_Log);
                sessionStorage.setItem('combranch', data2.Branch_Id);
                sessionStorage.setItem('enable_mis', data2.enable_mis);
                sessionStorage.setItem('enable_po', data2.enable_po);
                sessionStorage.setItem('tomsAccess', data2.tomsWinAccess);
                sessionStorage.setItem('ImageAccess', data2.ImageAccess);
                sessionStorage.setItem('enable_approval', data2.enable_approval);
                sessionStorage.setItem('enable_branch', data2.enable_branch);
                sessionStorage.setItem('CustomerLogin', 'YES');
                sessionStorage.setItem('isAuthenticated', true);
                sessionStorage.setItem('AdminUser', data2.AdminUser);
                sessionStorage.setItem('Approval2', data2.Approval2);
                sessionStorage.setItem('Approval3', data2.Approval3);
                sessionStorage.setItem('Username', data2.UserName);
                sessionStorage.setItem('Userid', data2.UserId);
                sessionStorage.setItem('customer_HO', data2.Customer_HeadOffice);
                sessionStorage.setItem('customer_HOID', data2.Customer_HoId);
                sessionStorage.setItem('CBranchName', data2.cbranchname);

                sessionStorage.setItem(
                  'enable_inventory',
                  data2.enable_inventory,
                );
                const WorkScenario =
                  data2.enable_mis === 'Y' &&
                    data2.enable_po === 'N' &&
                    data2.enable_approval === 'N' &&
                    data2.enable_branch === 'N'
                    ? 'mis_only_basic_scenario1'
                    : data2.enable_po === 'Y' &&
                      data2.enable_approval === 'N' &&
                      data2.enable_branch === 'N'
                      ? 'create_po_directly_scenario2'
                      : data2.enable_po === 'Y' &&
                        data2.enable_approval === 'Y' &&
                        data2.enable_branch === 'N'
                        ? 'po_with_approval_scenario3'
                        : data2.enable_po === 'Y' &&
                          data2.enable_approval === 'Y' &&
                          data2.enable_branch === 'Y'
                          ? 'po_with_approval_and_branches_scenario4'
                          : 'company_login';

                const UserRole =
                  data2.AdminUser === 'Y' &&
                    data2.Approval2 === 'N' &&
                    data2.Approval3 === 'N'
                    ? 'final_level'
                    : data2.AdminUser === 'N' &&
                      data2.Approval2 === 'Y' &&
                      data2.Approval3 === 'N'
                      ? 'level_one'
                      : data2.AdminUser === 'N' &&
                        data2.Approval2 === 'N' &&
                        data2.Approval3 === 'N'
                        ? 'branch_user'
                        : 'company_login';
                sessionStorage.setItem('WorkScenario', WorkScenario);
                sessionStorage.setItem('UserRole', UserRole);
                sessionStorage.setItem('Special_User1', 'N');
              }
            }
            dispatch({
              type: 'SET_USER',
              user: res.data,
            });

            if (
              Object.keys(res.data).length === 2 &&
              enabel[0].enable_mis == 'Y'
            ) {
              setTimeout(() => {
                history.push('/DashboardCustomer');
                setOpenLoader(false);
              }, 3000);
            } else {
              setLoginErr(true);
              setopen(true);
              setOpenLoader(false);
            }
            setTimeout(() => {
              setopen(false);
              setLoginErr(false);
              setOpenLoader(false);
            }, 2000);
          });
      } else {
        setopen(true);
        setTimeout(() => {
          setopen(false);
          setOpenLoader(false);
        }, 2000);
      }
    } else {
      e.preventDefault();
      if (username.length != 0 && password.length != 0) {
        const logidata = await axios.instance
          .post('/userlogin', {
            User_Code: `${username}`,
            New_Password: `${password}`,
          })
          .then(async res => {


            if (Object.keys(res.data).length === 2) {
              sessionStorage.setItem('user', JSON.stringify(res.data));
              console.log(res.data, 'user');
              setuserdata(res.data.eventlist);
              sessionStorage.setItem('authtoken', 'Bearer ' + res.data.token);
              for (const data2 of res.data.getlogin) {
                sessionStorage.setItem('Usercode', data2.User_Code);
                sessionStorage.setItem('Username', data2.User_Name);
                sessionStorage.setItem('Userid', data2.User_Id);
                sessionStorage.setItem('Special_User1', data2.Special_User);
                sessionStorage.setItem('username', data2.User_Name);
                sessionStorage.setItem('SalesMan', data2.SalesMan);
                sessionStorage.setItem('AdminUser1', data2.AdminUser);
                sessionStorage.setItem('CustomerLogin', 'NO');
                sessionStorage.setItem('isAuthenticated', true);
                sessionStorage.setItem('WorkScenario', 'company_login');
              }
              GetOnecompnayandDetails(companyid);
              Getuserrole()
            }

            dispatch({
              type: 'SET_USER',
              user: res.data,
            });

            if (Object.keys(res.data).length === 2) {
              setTimeout(() => {
                history.push('/DashboardCompany');
                setOpenLoader(false);
              }, 3000);
            } else {
              setopen(true);
            }
            setTimeout(() => {
              setopen(false);
              setOpenLoader(false);
            }, 2000);
          })

      } else {
        setopen(true);
        setTimeout(() => {
          setopen(false);
        }, 2000);
      }
    }
  };

  const Getallcompany = async name => {
    const tokent = sessionStorage.getItem('authtoken');
    const ordeheader = await axios.instance
      .post(
        `/getcompnaybranch`,
        {
          User_Code: name,
        },
        { Authorization: tokent, 'Content-Type': 'application/json' },
      )
      .then(res => {
        console.log(res.data, 'company');
        if (res.data.length != 0) {
          setcompanycollections(res.data);
          let Companycollection = [];
          Companycollection.push(res.data[0]);
          for (const Data of Companycollection) {
            console.log(Data.Branch_Name, 'yyyyyy');
            setcompanyid(Data.Company_Id);
          }
        } else {
          setcompanycollections([]);
        }
      });
  };

  useEffect(() => {
    const date = moment(new Date()).format('YYYYMMDD');
    console.log(date, 'date');
    setdate(date);
  }, []);

  const companyidvalue = async value => {
    setcompanyid(value);
    const tokent = sessionStorage.getItem('authtoken');
    const compbranch = sessionStorage.getItem('Companyid');
    const ordeheader = await axios.instance
      .get(`/Getcompnybranchone/${compbranch}`, {
        Authorization: tokent,
        'Content-Type': 'application/json',
      })
      .then(res => {
        console.log(res.data, 'test');
        for (const data of res.data) {
          console.log(data, 'companys');
          sessionStorage.setItem('Branch_Log', data.companybranch);
        }
      });
  };

  const changepss = () => {
    history.push('/ForgotPassword');
  };
  const handlechnge = () => {
    console.log(customerlogin);
    setcustomerlogin(!customerlogin);
  };
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <>
      <div className="w-100 d-flex flex-column justify-content-center align-items-center gap-2 p-4">
        <div>
          <p
            style={{
              color: '#04364A',
              fontSize: 20,
              fontWeight: '600',
              color: '#04364A',
              fontSize: 20,
              fontWeight: '600',
              textAlign: 'center',
            }}
            className="text-style22"
          >
            Login To Proceed
          </p>
        </div>

        <div className="w-100">
          <Form onSubmit={login} className="w-100">
            <FormGroup className="w-100">
              <Label className="text-style22 text-success">User code</Label>
              <Input
                value={username}
                placeholder="User code"
                bsSize="lg"
                onChange={e => {
                  Getallcompany(e.target.value);
                  setusername(e.target.value);
                }}
              />
            </FormGroup>

            <FormGroup className="w-100">
              <Label className="text-style22 text-success">Password</Label>
              <div className="d-flex flex-row justify-content-end align-items-center relative">
                <Input
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  placeholder="password"
                  onChange={e => setpassword(e.target.value)}
                  bsSize="lg"
                />
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  edge="end"
                  className="eyeIconforInput m-auto"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </div>
            </FormGroup>

            <FormGroup check className="my-2">
              <Input
                type="checkbox"
                defaultChecked={customerlogin}
                value={customerlogin}
                onChange={handlechnge}
              />{' '}
              <Label check className="text-style22">
                Supplier login
              </Label>
            </FormGroup>

            {customerlogin && (
              <FormGroup className="w-100 my-3">
                <Input
                  value={companyid}
                  onChange={e => {
                    companyidvalue(e.target.value);
                    console.log(e.target.value);
                  }}
                  type="select"
                >
                  <option>Select Company </option>
                  {companycollections.map((data, index) => (
                    <option key={index} value={data.Company_Id}>
                      {data.Company_Name}{' '}
                    </option>
                  ))}
                </Input>
              </FormGroup>
            )}

            {open ? (
              <p className="text-style22 text-danger text-center ">
                invalid credentials{' '}
              </p>
            ) : (
              ''
            )}
            <div className="text-center">
              <Button
                variant="contained"
                color="primary"
                fullWidth
                endIcon={<LoginIcon />}
                type="submit"
              >
                Log In
              </Button>
              {!customerlogin && (
                <p
                  style={{
                    color: 'black',
                    fontSize: '0.8rem',
                    cursor: 'pointer',
                    whiteSpace: 'nowrap',
                    textAlign: 'right',
                  }}
                  className="mt-2"
                  onClick={changepss}
                >
                  Forgot Password ?
                </p>
              )}
            </div>
          </Form>
        </div>

        {LoginErr ? (
          <SweetAlert
            title="You do not have access to this. Please contact the administrator."
            timeout={2000}
            style={{
              position: 'absolute',
              justifyContent: 'center',
              alignItems: 'center',
            }}
            showCloseButton={false}
            showConfirm={false}
            warning
            onConfirm={() => {
              setLoginErr(false);
            }}
          ></SweetAlert>
        ) : null}
      </div>

      <Dialog
        open={openLoader}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <LinearProgress />
      </Dialog>
    </>
  );
}
AuthForm.propTypes = {
  authState: PropTypes.oneOf([STATE_LOGIN, STATE_SIGNUP, STATE_FORGOT_PASSWORD])
    .isRequired,
  showLogo: PropTypes.bool,
  usernameLabel: PropTypes.string,
  usernameInputProps: PropTypes.object,
  passwordLabel: PropTypes.string,
  passwordInputProps: PropTypes.object,
  confirmPasswordLabel: PropTypes.string,
  confirmPasswordInputProps: PropTypes.object,
  onLogoClick: PropTypes.func,
  buttonText: PropTypes.string,
  onChangeAuthState: PropTypes.func.isRequired,
  children: PropTypes.node,
};

AuthForm.defaultProps = {
  authState: STATE_LOGIN,
  showLogo: true,
  usernameLabel: 'Email',
  usernameInputProps: {
    type: 'email',
    placeholder: 'your@email.com',
  },
  passwordLabel: 'Password',
  passwordInputProps: {
    type: 'password',
    placeholder: 'your password',
  },
  confirmPasswordLabel: 'Confirm Password',
  confirmPasswordInputProps: {
    type: 'password',
    placeholder: 'confirm your password',
  },
  onLogoClick: () => { },
};

export default AuthForm;
